import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import OrgUnitAdminUserConstants from '../OrgUnitAdminUserConstants';
import EntryNavLinks from '../../EntryNavLinks';
import NavLinks from '../../../meet/NavLinks';
import MyMeetsNavLinks from '../../../myMeets/MyMeetsNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitAthleteEntryRelayRosterEntryData from '../../../../state/omeMeetOrgUnitAthleteEntryRelayRosterEntry/UseOmeMeetOrgUnitAthleteEntryRelayRosterEntryData';
import useOUAdminEntryContextData from '../../../../state/ouAdminEntryContextView/UseOUAdminEntryContextData';
import useMyMeetsFiltersData from '../../../../state/myMeetsFilters/UseMyMeetsFiltersData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import Constants from '@usas/ui-web/utils/Constants';
import { formatTimeForDisplay, formatTimeForFilterObject } from '@usas/ui-web/utils/TimesUtils';

const useOrgUnitAdminRelayEntries = () => {
    const navigate = useNavigate();
    const { omeMeetState } = useOmeMeetData();
    const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
    const { omeMeetOrgUnitAthleteEntryRelayRosterEntryState, getOrgUnitAthleteEntryRelayRosterEntry }
        = useOmeMeetOrgUnitAthleteEntryRelayRosterEntryData();
    const { oUAdminEntryContextState } = useOUAdminEntryContextData();
    const { searchMeetState, setSearchMeetState } = useSearchMeetData();
    const { selectOrgUnitState } = useSelectOrgUnitData();
    const { myMeetsFiltersState } = useMyMeetsFiltersData();
        const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
    const [state, setState] = useState({ submitButton: '', tryRedirect: false });

    const onEditRelayClicked = (e, event) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        //Remove time cuts if they are the min/max default time cuts
        const eventCopy = JSON.parse(JSON.stringify(event));
        for (let i = 0; i < eventCopy.timeCuts?.length; i++) {
            if (eventCopy.timeCuts[i]?.noSlowerThanTimeCut &&
                formatTimeForDisplay(eventCopy.timeCuts[i]?.noSlowerThanTimeCut) === Constants.MAX_SWIM_TIME_STRING) {
                eventCopy.timeCuts[i].noSlowerThanTimeCut = null;
            }
            if (eventCopy.timeCuts[i]?.noFasterThanTimeCut &&
                formatTimeForFilterObject(eventCopy.timeCuts[i]?.noFasterThanTimeCut) === Constants.MIN_SWIM_TIME_STRING) {
                eventCopy.timeCuts[i].noFasterThanTimeCut = null;
            }
        }
        const updatedTimeCuts = []
        for (let i = 0; i < eventCopy.timeCuts?.length; i++) {
            if ((eventCopy.timeCuts[i]?.noFasterThanTimeCut && eventCopy.timeCuts[i]?.noFasterThanTimeCut !== null) ||
                (eventCopy.timeCuts[i]?.noSlowerThanTimeCut && eventCopy.timeCuts[i]?.noSlowerThanTimeCut !== null)) {
                updatedTimeCuts.push(eventCopy.timeCuts[i]);
            }
        }
        eventCopy.timeCuts = updatedTimeCuts;

        if (omeMeetState.route === '') {
            //OME Route
            navigate(EntryNavLinks.OU_ADMIN_RELAY_ENTRIES_TEAMS, { state: { event: eventCopy } });
        }
        else {
            //Meet Route
            navigate(NavLinks.OU_ADMIN_RELAY_ENTRIES_TEAMS, { state: { event: eventCopy } });
        }
    };

    const onNextButtonClicked = (e) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        setState({ ...state, submitButton: OrgUnitAdminUserConstants.CONTINUE, tryRedirect: true });
    };

    const onSaveAndExitButtonClicked = (e) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        setState({ ...state, submitButton: OrgUnitAdminUserConstants.SAVE_AND_EXIT, tryRedirect: true });
    };

    const onBackButtonClicked = (e) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        setState({ ...state, submitButton: OrgUnitAdminUserConstants.BACK, tryRedirect: true });
    };

    useEffect(() => {
        setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId &&
            omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoaded === false) {
            getOrgUnitAthleteEntryRelayRosterEntry(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [omeMeetOrgUnitEntryState, omeMeetOrgUnitAthleteEntryRelayRosterEntryState])

    useEffect(() => {
        if (state.tryRedirect === true) {
            if (state.submitButton === OrgUnitAdminUserConstants.CONTINUE) {
                if (omeMeetState.route !== '') {
                    navigate(NavLinks.OU_ADMIN_CREDENTIALS);
                }
                else {
                    navigate(EntryNavLinks.OU_ADMIN_CREDENTIALS);
                }
            }
            else if (state.submitButton === OrgUnitAdminUserConstants.SAVE_AND_EXIT) {
                if (omeMeetState.route !== '') {
                    setSearchMeetState({ ...searchMeetState, showMeetHeader: true });
                    navigate(NavLinks.MEET_ENTRY_TEAM, { state: { tryGetOmeMeet: true } });
                }
                else {
                    navigate(MyMeetsNavLinks.MEET_ENTRY_TEAM, { state: { selectOrgUnitState: selectOrgUnitState, myMeetsFiltersState: myMeetsFiltersState } });
                }
            }
            else if (state.submitButton === OrgUnitAdminUserConstants.BACK) {
                if (omeMeetState.route !== '') {
                    navigate(NavLinks.OU_ADMIN_ROSTER_ENTRIES);
                }
                else {
                    navigate(EntryNavLinks.OU_ADMIN_ROSTER_ENTRIES);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    return {
        oUAdminEntryContextState,
        omeMeetOrgUnitAthleteEntryRelayRosterEntryState,
        onEditRelayClicked,
        onNextButtonClicked,
        onSaveAndExitButtonClicked,
        onBackButtonClicked
    };
}

export default useOrgUnitAdminRelayEntries;